"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickableCell = exports.SpacedIcon = exports.CancelButton = exports.EditElement = exports.EllipsisText = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var storm_ui_1 = require("@amzn/storm-ui");
exports.EllipsisText = (0, styled_components_1.default)(storm_ui_1.Text)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"], ["\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"])));
exports.EditElement = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: ", ";\n"], ["\n  margin: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.micro;
});
exports.CancelButton = (0, styled_components_1.default)(storm_ui_1.TextButton)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  height: 100%;\n  padding: ", ";\n"], ["\n  height: 100%;\n  padding: ", ";\n"])), function (_a) {
    var withPadding = _a.withPadding, theme = _a.theme;
    return (withPadding ? theme.spacing.micro : 'unset');
});
exports.SpacedIcon = (0, styled_components_1.default)(storm_ui_1.Icon)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding-inline-start: ", ";\n"], ["\n  padding-inline-start: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.micro;
});
exports.ClickableCell = (0, styled_components_1.default)(storm_ui_1.TextButton)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  color: initial;\n  display: flex;\n  overflow: hidden;\n"], ["\n  color: initial;\n  display: flex;\n  overflow: hidden;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
